import { EventDate } from '../types/ViewModel/EventDate';
import { EventDateBM } from '../types/BusinessModel/EventDateBM';
import { removeTimezoneOffset } from 'odfjell-date-time-utils/dateTimeUtils';
import {
    floorTimeMsToMinute,
    parseUtcInstantMs,
    parseLocalTimeMs,
    registerLocalTime,
} from '../service-worker/offline_handlers/aol/event-time-keys.js';

export class EventDateFactory {
    constructor() {}

    //   private removeTimezoneOffset(date: Date | null): Date | null {
    //     if (date) {
    //       var offset = date.getTimezoneOffset() / -60;
    //       date.setHours(date.getHours() + offset);
    //       var reminderInHours = (offset - Math.floor(offset)) * 60;
    //       date.setMinutes(date.getMinutes() + reminderInHours);
    //       return date;
    //     }
    //     return null;
    // }

    public newEventDate(eventDate: EventDateBM): EventDate {
        if (eventDate) {
            const plannedDateTimeUtc = removeTimezoneOffset(eventDate.plannedDateTimeUTC);
            const plannedDateTimeLocal = removeTimezoneOffset(eventDate.plannedDateTimeLocal);
            const actualDateTimeUtc = removeTimezoneOffset(eventDate.actualDateTimeUTC);
            const actualDateTimeLocal = removeTimezoneOffset(eventDate.actualDateTimeLocal);
            // The Date fields above are parsed in the browser zone (a port local time in the browser's DST gap is shifted).
            // The exact port local time of the stored string is remembered on each actual Date, and ordering and day assignment read it
            // from there (event-time-keys.js). UTC is kept to the minute, as the ingestion transform (eventSortPipe) does to the Date.
            registerLocalTime(actualDateTimeUtc, floorTimeMsToMinute(parseUtcInstantMs(eventDate.actualDateTimeUTC)));
            registerLocalTime(actualDateTimeLocal, parseLocalTimeMs(eventDate.actualDateTimeLocal));
            return new EventDate(plannedDateTimeUtc, plannedDateTimeLocal, actualDateTimeUtc, actualDateTimeLocal);
        }
        return new EventDate(null, null, null, null);
    }

    public createNewEventDate(
        plannedDateTimeUtc: Date | null,
        plannedDateTimeLocal: Date | null,
        actualDateTimeUtc: Date | null,
        actualDateTimeLocal: Date | null
    ): EventDate {
        const plannedDateTimeUtcTemp = plannedDateTimeUtc ? new Date(plannedDateTimeUtc) : null;
        const plannedDateTimeLocalTemp = plannedDateTimeLocal ? new Date(plannedDateTimeLocal) : null;
        const actualDateTimeUtcTemp = actualDateTimeUtc ? new Date(actualDateTimeUtc) : null;
        const actualDateTimeLocalTemp = actualDateTimeLocal ? new Date(actualDateTimeLocal) : null;
        if (actualDateTimeUtcTemp) {
            actualDateTimeUtcTemp.setSeconds(0, 0);
        }
        if (actualDateTimeLocalTemp) {
            actualDateTimeLocalTemp.setSeconds(0, 0);
        }
        if (plannedDateTimeUtcTemp) {
            plannedDateTimeUtcTemp.setSeconds(0, 0);
        }
        if (plannedDateTimeLocalTemp) {
            plannedDateTimeLocalTemp.setSeconds(0, 0);
        }
        // A copy of a Date is a new object, so the exact local time of each input (a remembered one when the input came from the
        // parsed event, otherwise its fields) is registered on the copy; seconds are dropped like the Dates. A local time in the
        // browser's DST gap therefore survives an edit and save.
        registerLocalTime(actualDateTimeUtcTemp, actualDateTimeUtc ? floorTimeMsToMinute(parseLocalTimeMs(actualDateTimeUtc)) : null);
        registerLocalTime(actualDateTimeLocalTemp, actualDateTimeLocal ? floorTimeMsToMinute(parseLocalTimeMs(actualDateTimeLocal)) : null);
        return new EventDate(plannedDateTimeUtcTemp, plannedDateTimeLocalTemp, actualDateTimeUtcTemp, actualDateTimeLocalTemp);
    }

    public createEventDateFromCode(eventDate: EventDate): EventDate {
        // The Date objects are shared, so their remembered exact local times (event-time-keys.js) carry over to the clone.
        return new EventDate(
            eventDate.plannedDateTimeUtc,
            eventDate.plannedDateTimeLocal,
            eventDate.actualDateTimeUtc,
            eventDate.actualDateTimeLocal
        );
    }

    public createEmptyEventDate() {
        return new EventDate(null, null, null, null);
    }

    public createEventDateBM(eventDate: EventDate): any {
        return {
            plannedDateTimeUTC: eventDate.plannedDateTimeUtc,
            plannedDateTimeLocal: eventDate.plannedDateTimeLocal,
            actualDateTimeUTC: eventDate.actualDateTimeUtc,
            actualDateTimeLocal: eventDate.actualDateTimeLocal,
        };
    }
}
